export function isEmailVerificationRoute(path) {
  return path.startsWith('/verify-email/');
}
